/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

import TaskRecordListTabs from '../tasks-records-list/task-record-list-tabs';

const TaskTemplateRecordList = ({
  tasks = [],
  tasksMap,
  SelectedFilter,
  isFilterActive,
  searched,
  onSelectionNewWorkOrderOrRequest,
  loading,
  lastElement,
  taskTemplateRecords,
  setData,
  openModal,
  setSelectedOrderIds,
  tasksMapDataPoints,
  setSelectedFilterRT,
  isTaskTemplate = false,
  tab,
  setTab
}) => {
  useEffect(() => {
    if (parseInt(tab) !== 0) {
      setSelectedFilterRT({ RECENT: true });
    } else {
      setSelectedFilterRT({ DUE: true });
    }
  }, [tab]);

  return (
    <TaskRecordListTabs
      tab={tab}
      setTab={setTab}
      tasks={tasks || []}
      data={tasks}
      tasksMap={tasksMap || {}}
      SelectedFilter={SelectedFilter}
      isFilterActive={isFilterActive}
      searched={searched}
      openModal={openModal}
      setData={setData}
      onSelectionNewWorkOrderOrRequest={onSelectionNewWorkOrderOrRequest}
      white={loading ? false : location.pathname === '/task-records' ? true : false}
      lastElement={lastElement}
      taskTemplateRecords={taskTemplateRecords}
      setSelectedOrderIds={setSelectedOrderIds}
      tasksMapDataPoints={tasksMapDataPoints || {}}
      isTaskTemplate={isTaskTemplate}
    />
  );
};

export default TaskTemplateRecordList;
